import z from "zod";

const productChangedDataSchema = z.object({
    new: z.record(z.string(), z.unknown()),
    old: z.record(z.string(), z.unknown()).nullable(),
});

export { productChangedDataSchema };
